// extracted by css-extract-rspack-plugin
export default {"container":"container-l9zGMZ","info-row":"info-row-qB8Pyx","infoRow":"info-row-qB8Pyx"};// extracted by css-extract-rspack-plugin
export default {"container":"container-l9zGMZ","info-row":"info-row-qB8Pyx","infoRow":"info-row-qB8Pyx"};